<script lang="ts">
  import { Button, Dialog } from "@tastyworks/ui-library"
  import { createEventDispatcher } from "svelte"

  const dispatcher = createEventDispatcher()

  let open = $state(false)

  function handleSubmit() {
    dispatcher("deleteNote")
    open = false
  }
</script>

<Dialog.Root bind:open>
  <Dialog.Trigger variant="secondary">Delete</Dialog.Trigger>

  <Dialog.Portal>
    <Dialog.Overlay />
    <Dialog.Content class="w-96">
      <div class="w-full">
        <div class="flex flex-col gap-4">
          <p class="mb-4 text-center">
            Are you sure you want to delete this note?
          </p>
          <div class="flex justify-center gap-10">
            <Button
              name="submit"
              variant="secondary"
              type="submit"
              class="w-24"
              onclick={handleSubmit}>Confirm</Button
            >
            <Button
              name="close"
              variant="secondary"
              type="button"
              class="w-24"
              onclick={() => {
                open = false
              }}>Cancel</Button
            >
          </div>
        </div>
      </div></Dialog.Content
    >
  </Dialog.Portal>
</Dialog.Root>
